import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

import AiIconSearch from './icons/ai-icon-search.svg';

const IgniteAiSearchButton = ({
	openSearch,
}) => (
	<div className="ignite-ai__button-search-icon" role="presentation" title="Search with AI" onClick={() => openSearch()}>
		<SVG
			src={AiIconSearch}
			width={22}
			height={22}
		/>
	</div>
);

export default IgniteAiSearchButton;

IgniteAiSearchButton.propTypes = {
	openSearch: PropTypes.func.isRequired,
};
